import { Injectable } from '@angular/core';
import { HttpBaseService } from '../httpBase/httpBase.service';
import { Observable } from 'rxjs';
import {
  RFPFormItem,
  RFPFormItemResponse,
  RFPInsights,
  RFPListResponse,
  RFPMatchedContractorsResponse,
} from '../../models/rfp';
import { ENDPOINTS_BUYER } from '../../constants/ENDPOINTS';
import { ApiResponse } from '../../Interfaces/apiResponse.interface';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RfpService extends HttpBaseService {
  getAllRFPs(
    page = 1,
    items_per_page = 25,
    state?: string
  ): Observable<RFPListResponse> {
    const url = `${ENDPOINTS_BUYER.RFPS.GET_RFPS}?page=${page}&items_per_page=${items_per_page}${state ? '&state=' + state : ''}`;
    return this.get(url);
  }

  getRFPInsights(): Observable<ApiResponse<RFPInsights>> {
    const url = ENDPOINTS_BUYER.RFPS.GET_RFP_INSIGHTS;
    return this.get(url);
  }

  closeRFP(id: number): Observable<{ message?: string; errors?: unknown }> {
    const url = `${ENDPOINTS_BUYER.RFPS.PATCH_RFP_CANCEL}`.replace(
      '{rfp}',
      id.toString()
    );
    return this.patch(url, {});
  }

  getRFPById(id: number): Observable<RFPFormItemResponse> {
    const url = `${ENDPOINTS_BUYER.RFPS.GET_RFPS}/${id}`;
    return this.get(url);
  }

  saveRFP(
    data: Record<string, any>,
    id?: number
  ): Observable<{ rfp?: RFPFormItem; message?: string; errors?: unknown }> {
    const url = `${ENDPOINTS_BUYER.RFPS.POST_SAVE_RFP}/${id ?? ''}`;
    return this.post(url, data);
  }

  getMatchedContractors(
    page: number,
    rfpId: number,
    items_per_page: number
  ): Observable<RFPMatchedContractorsResponse> {
    const url =
      `${ENDPOINTS_BUYER.RFP_CONTRACTORS.GET_MATCHED_CONTRACTORS}?page=${page}&items_per_page=${items_per_page}`.replace(
        '{rfp}',
        rfpId.toString()
      );
    return this.get(url);
  }

  sendRfpToContractors(
    rfpId: number,
    contractors: number[]
  ): Observable<HttpResponse<{ message?: string; errors?: unknown }>> {
    const url = `${ENDPOINTS_BUYER.RFP_CONTRACTORS.SEND_RFP_TO_CONTRACTORS.replace('{rfp}', String(rfpId))}`;
    return this.post(url, { contractors }, { observe: 'response' });
  }

  getRfpContractorsList(
    id: number,
    page = 1,
    items_per_page = 12
  ): Observable<RFPMatchedContractorsResponse> {
    const url = `${ENDPOINTS_BUYER.RFP_CONTRACTORS.GET_CONTRACTORS_LIST.replace('{rfp}', String(id))}?page=${page}&items_per_page=${items_per_page}`;
    return this.get(url);
  }

  stopInquiries(rfpId: number) {
    const url = `${ENDPOINTS_BUYER.RFPS.POST_STOP_INQUIRIES.replace('{rfp}', String(rfpId))}`;
    return this.post(url, {}, { observe: 'response' });
  }
}
